import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { currentMonth, shiftMonth } from "@/lib/calendar";
import { formatDate } from "@/lib/format";

/**
 * ‹ September 2026 › — steps a "YYYY-MM" month back and forth. Never past the
 * current month: there is no attendance in a month that has not started.
 */
export function MonthStepper({ month, onChange }: { month: string; onChange: (month: string) => void }) {
  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon"
        aria-label="Previous month"
        onClick={() => onChange(shiftMonth(month, -1))}
      >
        <Icon name="caret-left" size={16} />
      </Button>
      <span className="min-w-[9.5rem] text-center text-sm font-medium text-ink">
        {formatDate(`${month}-01`, "MMMM yyyy") ?? month}
      </span>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Next month"
        disabled={month >= currentMonth()}
        onClick={() => onChange(shiftMonth(month, 1))}
      >
        <Icon name="caret-right" size={16} />
      </Button>
    </div>
  );
}
